// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__1B0BL","buttons":"SendReceipts_buttons__1s2ab","email":"SendReceipts_email__3FHun","bookApptTitle":"SendReceipts_bookApptTitle__3r060"};